import React from 'react';
import EventsHero from '../components/EventsHero/EventsHero';
import Footer from '../components/Footer/Footer';
import EventsIntro from '../components/EventsIntro/EventsIntro';
import UpcomingEvents from '../components/UpcomingEvents/UpcomingEvents';
import FooterCTA from '../components/FooterCTA/FooterCTA';


const EventsPage = () => {
  return (
    <>
      {/* Note: We are not using the main 'Header' component on this page */}
      <main>
        <EventsHero />
        <EventsIntro />
        <UpcomingEvents />
        {/* <UpcomingEvents /> */}
        <FooterCTA />
      </main>
      <Footer />
    </>
  );
};

export default EventsPage;